export const printApiMap = {
  // System Config
  '/api/v2/apps/config/printtool/print_item': 'PrintTool.PrintItem',
  '/api/v2/apps/config/printtool/re_print_item': 'PrintTool.RePrintItem',

  // Exception Center
  '/api/v2/apps/process/inbound/troubleshoot/print_inbound_exception_label':
    'TroubleshootTask.PrintInboundExceptionLabel',

  // Labor Management
  '/api/v2/apps/labor/activity/print_activity': 'Activity.PrintActivity',
  '/api/v2/apps/labor/staff/print_staff': 'Staff.PrintStaff',

  // Return Inbound
  '/api/v2/apps/process/inbound/riasn/print_asn_sku':
    'ReturnInboundOrder.PrintAsnSku',
  '/api/v2/apps/process/inbound/returninbound/reinboundgroup/print_group_counting_report':
    'DockManagement.PrintGroupCountingReport',
  '/api/v2/apps/process/inbound/returninbound/reinboundgroup/print_group_detail':
    'DockManagement.PrintGroupDetail',
  '/api/v2/apps/process/inbound/rimassputaway/print_location_id':
    'RiMassPutaway.PrintLocationId',
  '/api/v2/apps/process/inbound/riqc/print_sku_list': 'RiQc.PrintSkuList',
  '/api/apps/process/returninbound/riasn/print_liquidated_asn':
    'ReturnInboundOrder.PrintLiquidatedAsn',
  '/api/v2/apps/process/returninbound/returntobuyer/print_qc_data':
    'ReturnToBuyer.PrintQcData',
  '/api/apps/process/returninbound/returntoseller/print_qc_data':
    'ReturnToSeller.PrintQcData',
  '/api/v2/apps/process/returninbound/rtsshipping/confirm_print_shipping_batch':
    'RtsShipping.ConfirmPrintShippingBatch',
  '/api/v2/apps/process/returninbound/rtsshipping/print_carton':
    'RtsShipping.PrintCarton',
  '/api/v2/apps/process/returninbound/rtsshipping/print_carton_handover_note':
    'RtsShipping.PrintCartonHandoverNote',

  // Inbound
  '/api/v2/apps/process/inbound/trackingid/print_tracking_id_sku_uid':
    'TrackingId.PrintTrackingIdSkuUid',
  '/api/v2/apps/process/inbound/poasn/print_asn_sku':
    'InboundOrder.PrintAsnSku',
  '/api/v2/apps/process/inbound/poasn/print_asn': 'InboundOrder.PrintAsn',
  '/api/v2/apps/process/inbound/poasn/print_asn_virtual_sku_imei':
    'InboundOrder.PrintAsnVirtualSkuImei',
  '/api/v2/apps/process/inbound/poasn/print_rejected_asn':
    'InboundOrder.PrintRejectedAsn',
  '/api/v2/apps/process/inbound/poasn/print_carton_handover_note':
    'InboundOrder.PrintCartonHandoverNote',
  '/api/v2/apps/process/inbound/purchaseinbound/puinboundgroup/print_group_counting_report':
    'AsnGroup.PrintGroupCountingReport',
  '/api/v2/apps/process/inbound/purchaseinbound/puinboundgroup/print_group_detail':
    'AsnGroup.PrintGroupDetail',
  '/api/v2/apps/process/inbound/purchaseinbound/puinboundgroup/print_inbound_exception_note':
    'AsnGroup.PrintInboundExceptionNote',
  '/api/v2/apps/process/inbound/purchaseinbound/puinboundgroup/print_qc_result':
    'AsnGroup.PrintQcResult',
  '/api/v2/apps/process/inbound/purchaseinbound/puinboundgroup/print_qc_detail':
    'AsnGroup.PrintQcDetail',
  '/api/v2/apps/process/inbound/pomassputaway/print_location_id':
    'PoMassPutaway.PrintLocationId',
  '/api/v2/apps/process/inbound/parcelcounting/print_hand_over_note':
    'ParcelCounting.PrintHandOverNote',

  // RTS Outbound
  '/api/v2/apps/process/outbound/rtsorder/rtsshipment/print_rts_shipping':
    'RtsShipping.PrintRtsShipping',
  '/api/v2/apps/process/outbound/rtspicking/print_rts_picking':
    'RtsPicking.PrintRtsPicking',

  // Rack Transfer
  '/api/v2/apps/process/inventory/racktransfer/print_rack_transfer_task':
    'RackTransfer.PrintRackTransferTask',

  // Transfer
  '/api/v2/apps/process/inventory/transport/print_transfer_task':
    'Transfer.PrintTransferTask',
  '/api/v2/apps/process/inventory/transport/print_transport_task':
    'Transfer.PrintTransportTask',

  // Inventory Management
  // '/api/v2/apps/process/inventory/cyclecount/ccdifforder/print_cc_diff_order':
  //   'CcDiffOrder.PrintCcDiffOrder',
  '/api/v2/apps/process/inventory/cyclecount/cctask/print_cycle_count_task':
    'CcTask.PrintCycleCountTask',
  // '/api/v2/apps/process/inventory/fullstockcount/fscdifforder/print_fsc_diff_order':
  //   'FscDiffOrder.PrintFscDiffOrder',
  '/api/v2/apps/process/inventory/fullstockcount/fsctask/print_cycle_count_task':
    'FscTask.PrintCycleCountTask',
  '/api/v2/apps/process/inbound/rtputback/print_location_id':
    'RtPutback.PrintLocationId',
  '/api/v2/apps/process/inbound/rtmassputaway/print_location_id':
    'RtMassPutaway.PrintLocationId',

  // MT Outbound
  '/api/v2/apps/process/outbound/mtoshipbymtb/print_mtb_info':
    'ShippingByMtb.PrintMtbInfo',
  '/api/v2/apps/process/outbound/mtochecking/print_checking_mtb':
    'MtChecking.PrintCheckingMtb',
  '/api/v2/apps/process/outbound/mtopick/print_mto_mtb':
    'PoSorting.PrintMtoMtb',
  '/api/v2/apps/process/taskcenter/mtopicktask/print_mto_picking_list':
    'MtPicking.PrintMtoPickingList',
  '/api/v2/apps/process/outbound/mtopacking/get_print_data':
    'MtPacking.GetPrintData',

  // Sales Outbound
  '/api/v2/apps/process/outbound/salesorder/print_order_label':
    'SalesOrder.PrintOrderLabel',
  '/api/v2/apps/process/outbound/wave/print_wave_list':
    'ManualWave.PrintWaveList',
  // '/api/v2/apps/process/outbound/wave/inc_print_wave_count':
  //   'ManualWave.IncPrintWaveCount',
  '/api/v2/apps/process/outbound/sortwhilechecking/print_sort_while_checking_label':
    'SortingWhileChecking.PrintSortWhileCheckingLabel',
  '/api/v2/apps/process/outbound/sorting/print_sorting_label':
    'Sorting.PrintSortingLabel',
  '/api/v2/apps/process/taskcenter/checkingtask/print_checking_list':
    'Checking.PrintCheckingList',
  '/api/v2/apps/process/outbound/checking/print_checking_label':
    'Checking.PrintCheckingLabel',
  '/api/v2/apps/process/outbound/checking/print_mass_check_label':
    'Checking.PrintMassCheckLabel',
  '/api/v2/apps/process/outbound/checking/print_checking_medical_label':
    'Checking.PrintCheckingMedicalLabel',
  '/api/v2/apps/process/outbound/checking/print_parcel_split_unfinished_label':
    'Checking.PrintParcelSplitUnfinishedLabel',
  // '/api/v2/apps/process/outbound/checking/print_mass_check_label_count':
  //   'Checking.PrintMassCheckLabelCount',
  '/api/v2/apps/process/outbound/checking/print_mass_check_tbs_label':
    'Checking.PrintMassCheckTbsLabel',
  '/api/v2/apps/process/outbound/checking/print_mass_check_by_order_no_list':
    'Checking.PrintMassCheckByOrderNoList',
  '/api/v2/apps/process/outbound/checking/print_waybill_label':
    'Checking.PrintWaybillLabel',
  '/api/v2/apps/process/outbound/shipping/print_shipping_list':
    'Shipping.PrintShippingList',
  '/api/v2/apps/process/outbound/reversetask/print_reverse_task':
    'ReverseTask.PrintReverseTask',
  '/api/v2/apps/process/outbound/consumables/print_stock_take_task':
    'Consumables.PrintStockTakeTask',

  // Move
  '/api/v2/apps/process/inbound/mtmassputaway/print_location_id':
    'MtMassPutaway.PrintLocationId',
  '/api/v2/apps/process/taskcenter/trarrivingtask/print_arriving_task':
    'ArrivingTask.PrintArrivingTask',
} as const;

export type PrintApiKey = keyof typeof printApiMap;
export type PrintApiValue = (typeof printApiMap)[PrintApiKey];
